/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  all,
  call, put, takeEvery, takeLatest,
} from 'redux-saga/effects';
import { actions } from 'Slice/GroupsSlice';
import { actions as buyerActions } from 'Slice/BuyerGroupsPageSlice';
import { actions as peopleActions } from 'Slice/PeopleSlice';
import { actions as globalSearchActions } from 'Slice/GlobalSearchResultsSlice';
import { actions as advanceSearchActions } from 'Slice/AdvanceSearchSlice';
import { actions as companiesActions } from 'Slice/CompaniesSlice';
import { actions as topCompaniesActions } from 'Slice/TopCompanyEntitySlice';
import { actions as affinityActions } from 'Slice/AffinitySearchResultsSlice';
import axios from 'Utils/Axios';
import { API, FILE_DOWNLOAD_FAIL, FILE_DOWNLOAD_SUCCESS } from 'Utils/Constants';
import {
  AllGroupsResponse, CreatedGroup, DeleteGroupResponse, GroupExportRequest,
  ImportGroupRequest,
  MostActiveGroupsResponse,
  NewGroupResponse, OrgExecutiveResponse, PersonAddedInGroupResponse,
  PinGroupRequest,
  ShareGroupRequest, ShareGroupResponse, StaffBuyerGroupData,
} from 'Types/GroupsTypes';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  AddPersonInGroup, CreateGroup, DeleteGroup, GetAllGroups,
} from 'Types/RequestBodies';
import { actions as helperActions } from 'Slice/HelperSlice';
import { getCurrentTime, valueToObject, buildEditPersonNetworkRequest } from 'Utils/UtilityFunctions';
import { AddCompanyPopup } from 'Types/CompaniesTypes';
import { ExportFollowPeopleResponse } from 'Types/PersonTypes';
import { GlobalResponse } from 'Types/ResponseBodies';

export function* getMostActiveGroups() {
  try {
    const response: MostActiveGroupsResponse = yield call(
      axios.post,
      API.GET_ACTIVE_GROUPS,
      {},
    );
    if (response?.status === true) {
      yield put(actions.setMostActiveGroups(response?.response[0]));
    } else {
      yield put(actions.setMostActiveGroups({
        title: '',
        type: '',
        data: [],
        groupCount: 0,
      }));
    }
  } catch (err) {
    console.log(err);
    yield put(actions.setMostActiveGroups({
      title: '',
      type: '',
      data: [],
      groupCount: 0,
    }));
  }
}

export function* getGroups(dispatched: PayloadAction<GetAllGroups>) {
  const startTime = getCurrentTime();

  try {
    const response: AllGroupsResponse = yield call(
      axios.post,
      API.GET_ALL_GROUPS,
      dispatched?.payload,
    );
    const { offset } = dispatched.payload;
    const host = window.location.href;
    if (response?.status === true) {
      if (dispatched?.payload?.searchTerm && dispatched?.payload?.searchTerm !== '') {
        yield put(actions.setSearchedGroups(response?.response));
      } else yield put(actions.setAllGroups(response?.response));
      if (offset) {
        yield put(helperActions.callFlurryEvent(
          valueToObject(
            'buyer_group_groups_loaded',
            startTime,
            {
              ...dispatched?.payload,
              host,
            },
          ),
        ));
      }
    } else {
      yield put(actions.setAllGroups({
        title: '',
        type: '',
        data: [],
        groupCount: 0,
      }));
    }
  } catch (err) {
    console.log(err);
    yield put(actions.setAllGroups({
      title: '',
      type: '',
      data: [],
      groupCount: 0,
    }));
  }
}
export function* deleteGroup(dispatched: PayloadAction<DeleteGroup>) {
  const startTime = getCurrentTime();

  try {
    const response: DeleteGroupResponse = yield call(
      axios.post,
      API.DELETE_GROUP,
      dispatched?.payload,
    );

    if (response?.status === true) {
      yield put(buyerActions.setGroupDeleted(true));
      yield put(actions.groupDeleted(response?.response));
      yield put(companiesActions.deleteGroup(response.response.groupId));
      yield put(globalSearchActions.groupDeleted(response?.response));
      yield put(companiesActions.removeCompanyStaffBuyerGroup(dispatched?.payload.groupId));
      yield put(helperActions.callFlurryEvent(
        valueToObject('buyer_group_delete_group_succeeded', startTime, dispatched?.payload),
      ));
      yield put(helperActions.setNotification({
        message: response?.message,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
      }));
    } else if (response?.status === false) {
      yield put(actions.groupDeletionFailure());
      yield put(helperActions.setNotification({
        message: response?.message,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    }
  } catch (err) {
    yield put(actions.groupDeletionFailure());
    console.log(err);
  }
}

function* handleGroupCreationSuccess(response: NewGroupResponse, dispatched: PayloadAction<CreateGroup>, caller: 'createGroup' | 'mergeGroup') {
  const startTime = getCurrentTime();
  if (!response.message) {
    const res = response.response as AddCompanyPopup[];
    if (res && res.length) {
      yield all([
        put(companiesActions.buyerGroupsPopup(res[0])),
        put(actions.createdGroup({ response: [] })),
      ]);
    }
  } else {
    const res = response.response as StaffBuyerGroupData[];
    const createdGroup: CreatedGroup = {
      response: res,
      action: dispatched?.payload?.action,
    };
    if (res && res.length) {
      const { payload: { person_data: personData, deleteExisting, groupIds } } = dispatched;
      if (personData?.length) {
        const [{ entity_id: id }] = personData;
        yield all([
          put(peopleActions.updateRecommendedPeopleList(id)),
          put(globalSearchActions.searchFollowHandling(id)),
          put(advanceSearchActions.searchFollowHandling(id)),
          put(companiesActions.handleFollowGroupPeople(id)),
          put(topCompaniesActions.handleFollowGroupPeople(id)),
        ]);
      }
      yield all([
        put(actions.createdGroup(createdGroup)),
        put(companiesActions.followGroupPeople()),
        put(companiesActions.addCompanyStaffBuyerGroup(res)),
      ]);
      if (!dispatched.payload.displayMessage) {
        if (caller === 'createGroup') {
          yield put(helperActions.setNotification({
            message: response?.message,
            proTip: true,
            rightPlacement: false,
            groupId: res[0].groupId,
            classnameFlag: true,
          }));
        } else {
          yield put(helperActions.setNotification({
            message: 'Your group has been created successfully',
            proTip: false,
            rightPlacement: false,
            groupId: 0,
            classnameFlag: true,
          }));
        }
      } else {
        yield put(helperActions.setNotification({
          message: response?.message,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: true,
        }));
      }
      yield put(helperActions.callFlurryEvent(
        valueToObject('buyer_group_create_group_succeeded', startTime, dispatched?.payload),
      ));
      if (caller === 'mergeGroup') {
        if (deleteExisting && groupIds?.length) {
          const groupIdArr = groupIds.split(',').map((id) => Number(id.trim()));
          yield all(
            groupIdArr.map((id) => put(actions.removeGroup(id))),
          );
        }
        yield put(actions.setGroupDrawerOpen(false));
        yield put(actions.setMergeGroupsLoading(false));
        yield put(actions.setNewlycreatedGroupId(res[0].groupId));
        if (dispatched.payload.deleteExisting) {
          yield put(actions.setDeletePreviousGroup(true));
        }
      }
    }
  }
}

function* handleGroupCreationFailure(response: NewGroupResponse, dispatched: PayloadAction<CreateGroup>, caller: 'createGroup' | 'mergeGroup') {
  const { companyId, action } = dispatched.payload;
  if (response.message.length) {
    if (!companyId) {
      if (caller === 'createGroup') {
        yield put(helperActions.setNotification({
          message: response?.message,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: false,
        }));
      }
    } else if (!action) {
      yield put(actions.setShowMergePopup(true));
    }
  }
  yield put(actions.createdGroup({ response: [] }));
  if (caller === 'mergeGroup') {
    yield put(actions.setMergeGroupsLoading(false));
    yield put(actions.setGroupMergeError(response.message));
  }
}

export function* createGroup(dispatched: PayloadAction<CreateGroup>) {
  try {
    const response: NewGroupResponse = yield call(
      axios.post,
      API.CREATE_GROUP,
      dispatched?.payload,
    );
    if (response?.status === true) {
      yield call(handleGroupCreationSuccess, response, dispatched, 'createGroup');
    } else {
      yield call(handleGroupCreationFailure, response, dispatched, 'createGroup');
    }
  } catch (err) {
    console.log(err);
  }
}

export function* mergeGroups(dispatched: PayloadAction<CreateGroup>) {
  try {
    const response: NewGroupResponse = yield call(
      axios.post,
      API.MERGE_BUYER_GROUPS,
      dispatched?.payload,
    );
    if (response?.status === true) {
      yield call(handleGroupCreationSuccess, response, dispatched, 'mergeGroup');
    } else {
      yield call(handleGroupCreationFailure, response, dispatched, 'mergeGroup');
    }
  } catch (err) {
    yield put(helperActions.setNotification({
      message: 'Something went wrong',
      proTip: false,
      rightPlacement: false,
      groupId: 0,
      classnameFlag: false,
    }));
    yield put(actions.setMergeGroupsLoading(false));
    console.log(err);
  }
}

export function* addPersonInGroup(dispatched: PayloadAction<AddPersonInGroup>) {
  try {
    const response: PersonAddedInGroupResponse = yield call(
      axios.post,
      API.UPDATE_PERSON_PROFILE_FOLLOW,
      buildEditPersonNetworkRequest(dispatched.payload),
    );
    if (response?.status === true) {
      const { payload: { person_data: personData } } = dispatched;

      if (personData?.length) {
        const [{ entity_id: id }] = personData;
        yield all([
          put(peopleActions.updateRecommendedPeopleList(id)),
          put(globalSearchActions.searchFollowHandling(id)),
          put(advanceSearchActions.searchFollowHandling(id)),
          put(companiesActions.handleFollowGroupPeople(id)),
          put(topCompaniesActions.handleFollowGroupPeople(id)),
          put(affinityActions.personAddedToGroup(id)),
        ]);
        // Remove person from loading state
        yield put(actions.removePersonFromLoading(id));
      }
      yield put(helperActions.setNotification({
        message: response?.message,
        proTip: false,
        rightPlacement: true,
        groupId: response.response.groupId,
        classnameFlag: true,
      }));
      if (dispatched.payload.groupName && dispatched.payload.groupName !== '') {
        yield put(actions.personAddedInGroup(response.response));
      } else {
        if (personData?.length) {
          yield put(buyerActions.removePersonAfterAdd(personData[0]));
        }
        yield put(buyerActions.personAddedInGroup(response.response));
        yield put(buyerActions.resetHighlights({}));
        yield put(buyerActions.isAddRemovePersonInGroup(true));
      }
    } else {
      yield put(helperActions.setNotification({
        message: response?.message,
        proTip: false,
        rightPlacement: true,
        groupId: 0,
        classnameFlag: false,
      }));
      yield put(buyerActions.setIsError(true));
    }
  } catch (err) {
    // Remove all persons from loading state on error
    const { payload: { person_data: personData } } = dispatched;
    if (personData?.length) {
      const personIds = personData.map((person) => person.entity_id);
      yield all(personIds.map((id) => put(actions.removePersonFromLoading(id))));
    }
    console.log(err);
  }
}

export function* getOrganizationExecutives(dispatched: PayloadAction<GetAllGroups>) {
  const { payload } = dispatched;
  try {
    const response: OrgExecutiveResponse = yield call(
      axios.post,
      API.GET_ORG_EXECUTIVES,
      payload,
    );
    if (response?.status === true) {
      if (!payload.query) {
        yield put(actions.setOrganizationExecutives(response?.response));
      } else {
        yield put(actions.setSearchedExecutives(response?.response));
      }
    } else {
      yield put(actions.orgExecutivesFailed());
    }
  } catch (err) {
    console.log(err);
    yield put(actions.orgExecutivesFailed());
  }
}

export function* shareGroup(dispatched: PayloadAction<ShareGroupRequest>) {
  const { payload } = dispatched;
  const startTime = getCurrentTime();
  try {
    const response: ShareGroupResponse = yield call(
      axios.post,
      API.SHARE_GROUP,
      payload,
    );

    if (response?.status === true) {
      yield put(actions.groupShared());
      yield put(helperActions.setNotification({
        message: response?.message,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
      }));

      const { isDetailPage, groupIds } = payload;

      if (groupIds?.length > 1) {
        yield put(helperActions.callFlurryEvent(
          valueToObject('buyergroup_multiShare_complete', startTime, { feed_ids: groupIds.join(',') }),
        ));
      } else {
        yield put(helperActions.callFlurryEvent(
          valueToObject(`${isDetailPage ? 'homePage_' : ''}buyerGroup_share_complete${isDetailPage ? 'd' : ''}`, startTime, { feed_ids: groupIds.join(',') }),
        ));
      }
    } else {
      yield put(actions.groupSharedFailed());
    }
  } catch (err) {
    console.log(err);
    yield put(actions.groupSharedFailed());
  }
}
export function* exportGroupMembers(dispatched: PayloadAction<GroupExportRequest>) {
  const { groupId, filters } = dispatched.payload;
  try {
    const response: ExportFollowPeopleResponse = yield call(
      axios.post,
      API.EXPORT_GROUP_MEMBERS,
      {
        groupId,
        ...(filters && { filters }),
      },
    );
    if (response?.status === true) {
      const newWin = window.open(response.response?.url);
      if (newWin) {
        yield put(helperActions.setNotification({
          message: FILE_DOWNLOAD_SUCCESS,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: true,
        }));
      } else {
        yield put(helperActions.setNotification({
          message: FILE_DOWNLOAD_FAIL,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: false,
        }));
      }
    } else {
      yield put(helperActions.setNotification({
        message: FILE_DOWNLOAD_FAIL,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    }
  } catch (err) {
    console.log(err);
  }
}
export function* pinGroup(dispatched: PayloadAction<PinGroupRequest>) {
  try {
    const response: AllGroupsResponse = yield call(
      axios.post,
      API.PIN_GROUPS,
      dispatched?.payload,
    );
    if (response?.status === true) {
      yield put(actions.handlePinGroup(dispatched.payload));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* importGroup(dispatched: PayloadAction<ImportGroupRequest>) {
  try {
    const host = window.location.href;
    const response: GlobalResponse = yield call(
      axios.post,
      API.IMPORT_GROUP,
      dispatched?.payload,
    )
    if (response?.status === true) {
      yield put(actions.setImportGroup())
      yield put(helperActions.setNotification({
        message: response?.message,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
      }));
      yield put(actions.setUploadFileFlag(false));
      yield put(helperActions.callFlurryEvent(
        valueToObject('uploadFile_success_buyergroup', 0, {
          fileName: dispatched?.payload?.file?.name,
          host,
        })
      ))
    } else {
      yield put(actions.setImportGroup())
      yield put(helperActions.setNotification({
        message: response?.message,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
      yield put(actions.setUploadFileFlag(false));
      yield put(helperActions.callFlurryEvent(
        valueToObject('uploadFile_failure_buyergroup', 0, {
          fileName: dispatched?.payload?.file?.name,
          host,
        })
      ))
    }
  } catch (err) {
    console.log(err);
  }
}

export function* groupsSaga() {
  yield takeLatest(actions.getMostActiveGroups.type, getMostActiveGroups);
  yield takeLatest(actions.getAllGroups.type, getGroups);
  yield takeLatest(actions.deleteGroup.type, deleteGroup);
  yield takeLatest(actions.creatingGroup.type, createGroup);
  yield takeEvery(actions.addPersonInGroup.type, addPersonInGroup);
  yield takeLatest(actions.getOrganizationExecutives.type, getOrganizationExecutives);
  yield takeLatest(actions.shareGroup.type, shareGroup);
  yield takeLatest(actions.exportGroupMembers.type, exportGroupMembers);
  yield takeLatest(actions.mergeGroups.type, mergeGroups);
  yield takeLatest(actions.pinGroup.type, pinGroup);
  yield takeLatest(actions.importGroup.type, importGroup);
}
